// extracted by mini-css-extract-plugin
var _1 = "ClientNoteItem_author__+jdTG";
var _2 = "ClientNoteItem_container__ltwgy";
var _3 = "ClientNoteItem_content__b0oOM";
var _4 = "ClientNoteItem_header__Gk-AG";
var _5 = "ClientNoteItem_text__huxsH";
export { _1 as "author", _2 as "container", _3 as "content", _4 as "header", _5 as "text" }
